import { legalEntityEffects } from './load-all-legalentity.effect';
import { MyProfileEffects } from './my-profile-load.effect';
import { MyProfileEmailEffects } from './update-email.effect';
import { RequestAccessEffects } from './request-access.effect';

export const effects: any[] = [
  MyProfileEffects,
  MyProfileEmailEffects,
  RequestAccessEffects,
  legalEntityEffects
];